

















































































































import { defineComponent, toRefs, PropType, computed, onMounted, ref, watch } from '@vue/composition-api';
import {
  ACTION_TYPE,
  AdgroupFormData,
  AdType,
  AppInfo,
  BrandSafetyTrackTypeMap,
  CampaignFormData,
  FullNormalFormData,
  AcoFormData,
  ViewabilityTrackTypeMap,
  PixelInfo,
  RejectInfo,
} from '@tt4b/ttam-enums';

import Tracking from './index';
import { i18n } from '@tt4b/ttam-i18n';
import { useCreativeTrackingValidate } from '@tt4b/ttam-hooks';
import AdTracking from './index';
import TtamBackgroundContainer from '../../common/background-container/index.vue';
import TtamEditBackgroundContainer from '../../common/tracking-background-container/index.vue';
import TtamTiktokEventTracking from './tiktok-events-tracking/index.vue';
import { useFousTrackTiktokEvent } from './hooks/useFocusMode';

const name = 'ttam-tracking-compose';

export default defineComponent({
  name,
  components: {
    TtamBackgroundContainer,
    TtamEditBackgroundContainer,
    TtamTrackingUrlSetting: Tracking.TtamTrackingUrlSetting,
    TtamTrackingViewability: Tracking.TtamTrackingViewability,
    TtamTrackingBrandSafety: Tracking.TtamTrackingBrandSafety,
    TtamTrackingBrandSafetyTips: Tracking.TtamTrackingBrandSafetyTips,
    TtamTrackingRetargetingTip: Tracking.TtamTrackingRetargetingTip,
    TtamTiktokEventTracking,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({} as FullNormalFormData),
    },
    isDisabledCreative: {
      type: Boolean,
      default: false,
    },
    appInfo: {
      type: Object as PropType<AppInfo>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<typeof ACTION_TYPE[keyof typeof ACTION_TYPE]>,
      default: ACTION_TYPE.CREATE,
    },
    currentAdType: {
      type: Number as PropType<AdType>,
      default: undefined,
    },
    copyNum: {
      type: Number,
      default: 20,
    },
    adGroupPixelInfo: {
      type: Object as PropType<PixelInfo>,
      default: () => ({}),
    },
    rejectInfo: {
      type: Object as PropType<RejectInfo>,
      default: () => ({}),
    },
    isNewTiktokEventTrack: {
      type: Boolean,
      default: false,
    },
    originEditFormData: {
      type: Object as PropType<Partial<FullNormalFormData>>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const {
      adgroupData,
      campaignData,
      creativeData,
      isDisabledCreative,
      appInfo,
      createMode,
      currentAdType,
      rejectInfo,
      originEditFormData,
    } = toRefs(props);
    const {
      domainValidator,
      trackUrlValidator,
      brandSafetyTrackTypeValidator,
      brandSafetyTrackUrlValidator,
      actionTrackUrlValidator,
      viewabilityTrackUrlValidator,
    } = useCreativeTrackingValidate({ createMode, appInfo, adgroupData });
    const { isOnlyShowImpressionUrl, trackingUrlTitle } = Tracking.usePropsImpressionUrl({
      adgroupData,
      campaignData,
      currentAdType,
    });
    const { isShowTrackingUrl, shouldClickTrackShow } = Tracking.useTrackUrlShow({
      adgroupData,
      campaignData,
      creativeData,
      appInfo,
      rejectInfo,
    });
    const { closeLoopTrackingShow } = AdTracking.usePropsTrackCloseLoopVisible({
      campaignData,
      creativeData: originEditFormData as any,
      createMode,
    });

    const {
      isDisabledClickTrackUrl,
      isHasEventsTrackingModule,
      isShowWebsiteEvents,
      isShowAppEvents,
      isShowPixel,
      isRetargetingApp,
      creativeConfig: trackUrlCreativeConfig,
    } = Tracking.useTrackUrl({
      adgroupData,
      campaignData,
      creativeData,
      appInfo,
      createMode,
      isDisabledCreative,
    });

    const { isShowOfflineEvents } = Tracking.useOfflineEventsDefaultData({
      createMode,
      creativeData,
      adgroupData,
    });

    const { options: tiktokEventOptions } = useFousTrackTiktokEvent({
      creativeData,
      isShowWebsiteEvents,
      isShowOfflineEvents,
      isShowAppEvents,
      isRetargetingApp,
    });

    const { visible: tipVisible } = Tracking.usePropsTrackTipVisible({
      campaignData,
      adgroupData,
      createMode,
    });

    const _trackUrl = computed({
      get: () => creativeData.value?.trackUrl?.[0] ?? '',
      set: (val: string) => emit('change', { trackUrl: [val] }),
    });

    const _actionTrackUrl = computed({
      get: () => creativeData.value?.actionTrackUrl?.[0] ?? '',
      set: (val: string) => emit('change', { actionTrackUrl: [val] }),
    });

    const {
      isShowViewability,
      isOnlyShowViewIAS,
      viewabilityTrackTitle,
      availableViewabilityOptions,
      isDisabledViewability,
      isOnlyOneViewTrackType,
      onViewTrackDataChange,
    } = Tracking.useViewAbility({
      adgroupData,
      creativeData,
      campaignData,
      createMode,
    });

    const {
      isOnlyShowZefr,
      isOnlyShowBsIas,
      isOnlyShowBsdv,
      isShowBrandSafety,
      isDisabledBrandSafetyTrack,
      isDisabledBrandSafetyToggle,
      isBrandSafetyHasIas,
      isOnlyOneBrandSafetyTrackType,
      brandSafetyTrackTitle,
      brandSafetyTrackTitleHint,
      availableBrandSafetyOptions,
      isNotSupportedLocationForAllTrackType,
      isSupportBrandSafetyTracking,
    } = Tracking.useBrandSafetyProps({
      adgroupData,
      campaignData,
      creativeData,
      isDisabledCreative,
    });

    const { isShowTrackingMore } = Tracking.useIsShowTrackingMore({
      adgroupData,
      campaignData,
      creativeData,
      isDisabledCreative,
      appInfo,
      rejectInfo,
      createMode,
    });

    const _brandSafetySwitch = ref(Boolean(creativeData.value.brandSafetyPostbidPartner));

    /** ad type变了，会切换vuex数据。需要 重新初始化Brand Safety的开关状态 */
    watch(currentAdType, () => {
      _brandSafetySwitch.value = Boolean(creativeData.value.brandSafetyPostbidPartner);
    });

    const _brandSafetyUrl = computed({
      get: () => creativeData.value.brandSafetyVastUrl || '',
      set: (val: string) => {
        emit('change', {
          brandSafetyVastUrl: creativeData.value.brandSafetyPostbidPartner === BrandSafetyTrackTypeMap.IAS ? val : '',
        });
      },
    });

    const _brandSafetyTrackType = computed({
      get: () => creativeData.value.brandSafetyPostbidPartner ?? undefined,
      set: (val: number | string) => {
        emit('change', {
          brandSafetyPostbidPartner: val,
          brandSafetyVastUrl: val === BrandSafetyTrackTypeMap.IAS ? _brandSafetyUrl.value : '',
        });
      },
    });

    const handleViewAbilitySelectIAS = () => {
      _brandSafetySwitch.value = true;
      _brandSafetyTrackType.value = BrandSafetyTrackTypeMap.IAS;
    };

    const _viewabilitySwitch = computed({
      get: () =>
        Boolean(creativeData.value?.vastMoat || creativeData.value?.vastDoubleVerify || creativeData.value?.vastIas),
      set: (isOpen: boolean) => {
        const firstViewabilityOptions = availableViewabilityOptions.value[0];
        const result = onViewTrackDataChange(
          isOpen && firstViewabilityOptions?.value ? firstViewabilityOptions.value : 0,
        );

        // 联动逻辑
        if (result.vastIas && isBrandSafetyHasIas.value) {
          handleViewAbilitySelectIAS();
        }
        emit('change', result);
      },
    });

    const _viewabilityUrl = computed({
      get: () => creativeData.value.vastUrl ?? '',
      set: val => emit('change', { vastUrl: val }),
    });

    const _viewabilityType = computed({
      get: () => {
        if (creativeData.value.vastMoat) {
          return ViewabilityTrackTypeMap.MOAT;
        } else if (creativeData.value.vastDoubleVerify) {
          return ViewabilityTrackTypeMap.DV;
        } else if (creativeData.value.vastIas) {
          return ViewabilityTrackTypeMap.IAS;
        }

        return ViewabilityTrackTypeMap.OFF;
      },
      set: (val: number) => {
        if (val === ViewabilityTrackTypeMap.IAS && isBrandSafetyHasIas.value) {
          handleViewAbilitySelectIAS();
        }
        emit('change', onViewTrackDataChange(val));
      },
    });

    const brandSafetyTrackSwitchHint = computed(() => {
      if (isNotSupportedLocationForAllTrackType.value) {
        return i18n.t('postbid_measurement_grayout_tooltips_limitation_location');
      }

      if (
        _viewabilityType.value === ViewabilityTrackTypeMap.IAS &&
        _brandSafetySwitch.value &&
        _brandSafetyTrackType.value === BrandSafetyTrackTypeMap.IAS
      ) {
        return i18n.t('module_brand_safety_close_brand_safety_ias_tip');
      }

      return '';
    });

    const { load: loadBrandSafetySupportCountries, isLoading: isBrandSafetyOptionsLoading } =
      Tracking.useBrandSafetySupport();

    const isBrandSafetyIASSelect = computed(() => _brandSafetyTrackType.value === BrandSafetyTrackTypeMap.IAS);
    const isViewAbilityIASSelect = computed(() => _viewabilityType.value === ViewabilityTrackTypeMap.IAS);

    const viewAbilitySelectIAS = computed(() => isViewAbilityIASSelect.value && isBrandSafetyHasIas.value);

    const viewabilityTrackSwitchHint = computed(() => {
      if (
        creativeData.value.vastIas &&
        _viewabilitySwitch.value &&
        creativeData.value.brandSafetyPostbidPartner === BrandSafetyTrackTypeMap.IAS
      ) {
        return i18n.t('module_brand_safety_close_viewability_ias_tip');
      }
      return '';
    });
    const bsTrackUrlRules = computed(() => {
      if (_brandSafetySwitch.value && !creativeData.value.brandSafetyPostbidPartner) {
        return brandSafetyTrackTypeValidator.value;
      }
      if (creativeData.value.brandSafetyPostbidPartner === BrandSafetyTrackTypeMap.IAS) {
        return brandSafetyTrackUrlValidator.value;
      }

      return [];
    });

    const onBrandSafetySwitchChange = async (open: boolean) => {
      _brandSafetySwitch.value = open;
      if (!open) {
        emit('change', {
          brandSafetyPostbidPartner: BrandSafetyTrackTypeMap.UNSET,
          brandSafetyVastUrl: '',
        });
        emit('clear-validate', 'brandSafetyVastUrl');
        return;
      }
      await loadBrandSafetySupportCountries();
      const firstAvailableOption = availableBrandSafetyOptions.value.find(i => !i.disabled);
      // 当两个可见性可选时, 不回弹toggle
      if (firstAvailableOption?.value) {
        emit('change', {
          brandSafetyPostbidPartner: firstAvailableOption.value,
        });
      } else if (isOnlyOneBrandSafetyTrackType.value) {
        _brandSafetySwitch.value = false;
      } else {
        _brandSafetySwitch.value = true;
      }
    };

    onMounted(() => {
      if (isSupportBrandSafetyTracking.value) {
        loadBrandSafetySupportCountries();
      }
    });
    return {
      _trackUrl,
      _actionTrackUrl,

      _viewabilitySwitch,
      _viewabilityUrl,
      _viewabilityType,

      _brandSafetyUrl,
      _brandSafetySwitch,
      _brandSafetyTrackType,

      domainValidator,
      trackUrlValidator,
      bsTrackUrlRules,
      actionTrackUrlValidator,
      viewabilityTrackUrlValidator,

      isShowPixel,
      isDisabledClickTrackUrl,
      isHasEventsTrackingModule,
      tiktokEventOptions,
      isRetargetingApp,
      trackUrlCreativeConfig,
      isShowWebsiteEvents,
      isShowOfflineEvents,
      isShowAppEvents,

      isShowTrackingMore,
      isOnlyShowImpressionUrl,
      trackingUrlTitle,
      isOnlyShowZefr,
      isOnlyShowBsIas,
      isOnlyShowBsdv,
      isOnlyOneBrandSafetyTrackType,
      tipVisible,
      viewAbilitySelectIAS,

      name,
      viewabilityTrackTitle,
      availableBrandSafetyOptions,
      isDisabledBrandSafetyTrack,
      isShowBrandSafety,
      isBrandSafetyIASSelect,
      isBrandSafetyOptionsLoading,
      BrandSafetyTrackTypeMap,
      brandSafetyTrackTitle,
      brandSafetyTrackTitleHint,
      isDisabledBrandSafetyToggle,
      isNotSupportedLocationForAllTrackType,
      brandSafetyTrackSwitchHint,

      isShowViewability,
      isDisabledViewability,
      isOnlyOneViewTrackType,
      viewabilityTrackSwitchHint,
      availableViewabilityOptions,
      isViewAbilityIASSelect,
      isOnlyShowViewIAS,

      onBrandSafetySwitchChange,
      isShowTrackingUrl,
      closeLoopTrackingShow,
      shouldClickTrackShow,
    };
  },
});
